
define('text!modules/creatives/bulkedit/templates/entity_grid_item.html',[],function () { return '<div class="item">\n\t<div class="column name">{{name}}</div>\n\t<div class="column id">{{#consistencyEnabled}}{{pos}}{{/consistencyEnabled}}{{^consistencyEnabled}}{{id}}{{/consistencyEnabled}}</div>\n</div>\n';});

